import serviceAxios from './serviceAxios';

const fetch = {
    get: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'get',
            params: data,
            ...config
        }).catch((err) => {
            console.log(err);
        });
    },
    post: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'post',
            data,
            ...config
        }).catch((err) => {
            console.log(err);
        });
    },
    put: function (url, data, config = {}) {
        return serviceAxios({
            url: url,
            method: 'put',
            data,
            ...config
        }).catch((err) => {
            console.log(err);
        });
    }
};

export default fetch;
